module.exports = __webpack_public_path__ + "img/audit.7af4f425.svg";